import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import Wrapper from '../../components/Wrapper'
import Header from '../../components/Header'
import Body from '../../components/Body'
import Footer from '../../components/Footer'
import TopBar from '../../components/TopBar'
import SubmitButton from '../../components/SubmitButton'
import { motorActions } from '../../actions'

import BackgroundImage from '../../assets/motor/background.png'
import Icon from '@material-ui/core/Icon'
import _ from 'lodash'

import BrandPicker from './../../components/BrandPicker'
import ModelPicker from './../../components/ModelPicker'
import YearPicker from './../../components/YearPicker'

const fontDefault = {
  fontFamily: 'thonburiregular',
  fontStyle: 'normal',
}

const styles = {
  textTopBar: {
    ...fontDefault,
    color: '#333333',
    fontSize: '18px',
    fontWeight: 'bold',
  },
  backgroundImageContainer: {
    position: 'absolute',
    height: '160px',
    width: '100%',
  },
  backgroundImage: {
    height: '160px',
    objectFit: 'cover',
    width: '100%',
  },
  card: {
    borderRadius: '8px',
    boxShadow: '0 2px 4px 0 rgba(94, 92, 92, 0.3)',
    backgroundImage: 'linear-gradient(162deg, #ffffff, #ffffff)',
    margin: '16px',
  },
  cardHeader: {
    backgroundColor: '#ddedfe',
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
    padding: '16px',
  },
  cardTitle: {
    color: '#118df5',
    fontSize: '18px',
    ...fontDefault,
  },
  cardContent: {
    padding: '16px',
  },
  container: {
    marginTop: '10px',
    position: 'relative',
  },
  fieldTitle: {
    ...fontDefault,
    fontSize: '16px',
    color: '#0e162c',
  },
  inputContainer: {
    marginTop: '7px',
    padding: '16px',
    borderRadius: '8px',
    boxShadow: '0 1px 4px 0 rgba(157, 157, 157, 0.3)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  inputContainerDisable: {
    marginTop: '7px',
    padding: '16px',
    borderRadius: '8px',
    boxShadow: '0 1px 4px 0 rgba(157, 157, 157, 0.3)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#EFEFEF',
  },
  fieldValueBlank: {
    color: '#cdd2de',
  },
  fieldValue: {
    color: '#0e162c',
  },
}

class SelectCarModel extends Component {
  state = {
    showBrandPicker: false,
    showModelPicker: false,
    showYearPicker: false,
  }

  backButton = () => {
    const {
      history: { push },
    } = this.props
    push('/')
    document.getElementById("rootScreen").scrollTo(0, 0)
  }

  goToNextPage = async () => {
    const {
      history: { push },
    } = this.props

    push('/select-package')
    document.getElementById("rootScreen").scrollTo(0, 0)
  }

  componentDidMount = () => {
    const { currentProduct } = this.props
    if (!!currentProduct === false) {
      const {
        history: { push },
      } = this.props
      push('/')
      document.getElementById("rootScreen").scrollTo(0, 0)
    }
  }

  openBrandPicker = () => {
    this.setState({
      showBrandPicker: true,
    })
  }

  closeBrandPicker = () => {
    this.setState({
      showBrandPicker: false,
    })
  }

  openModelPicker = () => {
    this.setState({
      showModelPicker: true,
    })
  }

  closeModelPicker = () => {
    this.setState({
      showModelPicker: false,
    })
  }

  openYearPicker = () => {
    this.setState({
      showYearPicker: true,
    })
  }

  closeYearPicker = () => {
    this.setState({
      showYearPicker: false,
    })
  }

  render() {
    const { classes, carBrand, carModel, carYear } = this.props
    const { showBrandPicker, showModelPicker, showYearPicker } = this.state
    return (
      <Wrapper>
        <Body style={{ backgroundColor: '#eff0f4' }}>
          <div className={classes.backgroundImageContainer}>
            <img
              alt="background_image"
              className={classes.backgroundImage}
              src={BackgroundImage}
            />
          </div>
          <div className={classes.container}>
            <Grid container>
              <Grid item xs={12}>
                <div className={classes.card}>
                  <div className={classes.cardHeader}>
                    <span className={classes.cardTitle}>ข้อมูลเกี่ยวกับรถ</span>
                  </div>
                  <div className={classes.cardContent}>
                    <div className={classes.fieldContainer}>
                      <span className={classes.fieldTitle}>
                        เลือกยี่ห้อรถยนต์
                      </span>
                      <div
                        className={classes.inputContainer}
                        onClick={this.openBrandPicker}
                      >
                        <span
                          className={
                            carBrand
                              ? classes.fieldValue
                              : classes.fieldValueBlank
                          }
                        >
                          {carBrand ? carBrand : 'เลือก'}
                        </span>
                        <Icon style={{ color: '#4b5161', fontSize: '12px' }}>
                          arrow_forward_ios
                        </Icon>
                      </div>
                    </div>
                    <br />
                    <div
                      className={classes.fieldContainer}
                      onClick={() => {
                        if (carBrand) {
                          this.openModelPicker()
                        }
                      }}
                    >
                      <span className={classes.fieldTitle}>
                        เลือกรุ่นรถยนต์
                      </span>
                      <div
                        className={
                          carBrand
                            ? classes.inputContainer
                            : classes.inputContainerDisable
                        }
                      >
                        <span
                          className={
                            carModel
                              ? classes.fieldValue
                              : classes.fieldValueBlank
                          }
                        >
                          {carModel ? _.get(carModel, 'label', '') : 'เลือก'}
                        </span>
                        <Icon style={{ color: '#4b5161', fontSize: '12px' }}>
                          arrow_forward_ios
                        </Icon>
                      </div>
                    </div>
                    <br />
                    <div
                      className={classes.fieldContainer}
                      onClick={() => {
                        if (carBrand && carModel) {
                          this.openYearPicker()
                        }
                      }}
                    >
                      <span className={classes.fieldTitle}>
                        เลือกปีที่จดทะเบียน
                      </span>
                      <div
                        className={
                          carBrand && carModel
                            ? classes.inputContainer
                            : classes.inputContainerDisable
                        }
                      >
                        <span
                          className={
                            carYear
                              ? classes.fieldValue
                              : classes.fieldValueBlank
                          }
                        >
                          {carYear ? carYear : 'เลือก'}
                        </span>
                        <Icon style={{ color: '#4b5161', fontSize: '12px' }}>
                          arrow_forward_ios
                        </Icon>
                      </div>
                    </div>
                    <br />
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
          <BrandPicker
            open={showBrandPicker}
            onBack={this.closeBrandPicker}
            history={this.props.history}
          />
          <ModelPicker
            open={showModelPicker}
            onBack={this.closeModelPicker}
            history={this.props.history}
          />
          <YearPicker
            open={showYearPicker}
            onBack={this.closeYearPicker}
            history={this.props.history}
          />
        </Body>
        <Footer style={{ backgroundColor: '#eff0f4' }}>
          <SubmitButton
            onClick={() => {
              if (carBrand && carModel && carYear) {
                this.goToNextPage()
              }
            }}
          >
            เช็คราคา
          </SubmitButton>
        </Footer>
        <Header>
          <TopBar arrowLeft={this.backButton}>
            <Typography align="center" className={classes.textTopBar}>
              เลือกประเภท
            </Typography>
          </TopBar>
        </Header>
      </Wrapper>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentProduct: _.get(state, 'motor.userInput.currentProduct', ''),
    carBrand: _.get(state, 'motor.userInput.carBrand', ''),
    carModel: _.get(state, 'motor.userInput.carModel', ''),
    carYear: _.get(state, 'motor.userInput.carYear', ''),
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setPackage: (data, policyTypes, registerYear) =>
      dispatch(motorActions.setPackage(data, policyTypes, registerYear)),
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(SelectCarModel))
